<template>
  <div class="app-container">
    <div style="margin-bottom: 10px">
      <el-button
        style="margin-right: 10px"
        type="primary"
        @click="addMenu()"
        v-if="roles.includes('/user/house_user_add')"
        >添加</el-button
      >
      <!-- <el-button
        size="medium"
        type="info"
        @click="downloadFile()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/company_user/import_user_template')"
        >下载模板</el-button
      >
      <el-button
        size="medium"
        type="success"
        @click="leadIn()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/company_user/import_user')"
        >导入</el-button
      > -->
    </div>
    <el-select
      filterable
      v-if="userInfo.is_super == 1"
      class="screenInput"
      v-model="screen.park_id"
      placeholder="请选择园区"
    >
      <el-option label="全部" value=""></el-option>
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in parkList"
        :key="index"
      ></el-option>
    </el-select>
    <el-input
      class="screenInput"
      v-model="screen.name"
      placeholder="请输入用户名称"
    ></el-input>
    <el-input
      class="screenInput"
      v-model="screen.phone"
      placeholder="请输入手机号"
      maxlength="11"
    ></el-input>
    <el-button type="primary" @click="(screen.page = 1), fetchData()"
      >筛选</el-button
    >
    <el-button type="primary" plain @click="chongZhi()">重置</el-button>

    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="用户姓名">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="昵称">
        <template slot-scope="scope">
          {{ scope.row.nick_name }}
        </template>
      </el-table-column> -->
      <el-table-column label="头像" align="center">
        <template slot-scope="scope">
          <img
            v-if="scope.row.avatar_url"
            class="tableIcon"
            alt=""
            srcset=""
            :src="imageOss + scope.row.avatar_url"
          />
        </template>
      </el-table-column>
      <el-table-column label="手机号" align="center">
        <template slot-scope="scope">
          {{ scope.row.phone }}
        </template>
      </el-table-column>
      <el-table-column label="园区名称" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.user_park_company_rel.length">
            <div
              class="line2"
              v-for="(item, i) in scope.row.user_park_company_rel"
              :key="i"
            >
              {{ item.park_name }}
            </div>
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="企业名称" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.user_park_company_rel.length">
            <div
              class="line2"
              v-for="(item, i) in scope.row.user_park_company_rel"
              :key="i"
            >
              {{ item.name }}
            </div>
          </span>
        </template>
      </el-table-column> -->
      <el-table-column
        align="center"
        prop="created_at"
        label="操作"
        width="250"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            v-if="roles.includes('/user/house_user_info')"
            size="mini"
            type="warning"
            @click="handleSee(scope.row)"
            >查看</el-button
          >
          <el-button
            v-if="roles.includes('/user/house_user_edit')"
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <!-- <el-button
            v-if="roles.includes('/user/house_user_edit')"
            size="mini"
            type="danger"
            @click="delHouse_user(scope.row)"
            >删除</el-button
          > -->
          <!-- v-if="roles.includes('/company_user/del')" -->
          <!-- <el-button size="mini" type="danger" @click="openUserRole(scope.row)"
            >查看角色</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="900px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="cztype != 'see' ? rules : rules1"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="姓名" prop="name">
          <el-input
            :disabled="cztype == 'see'"
            v-model="ruleForm.name"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            :disabled="cztype == 'see'"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
            maxlength="11"
            v-model="ruleForm.phone"
            :disabled="cztype != 'add'"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="头像" prop="icon">
          <el-upload
            :limit="1"
            ref="upload"
            name="file[]"
            :data="{ type: 'image' }"
            :action="ossUpload"
            :file-list="fileList"
            :headers="{ token: token }"
            list-type="picture-card"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            :disabled="cztype == 'see'"
            :before-upload="beforeAvatarUpload"
            accept=".jpg,.png,.jpeg"
            :class="ruleForm.avatar_url  ? 'hide' : ''"
          >
            <i class="el-icon-plus"></i> </el-upload
          ><!-- 已修改 -->
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="ruleForm.sex" :disabled="cztype == 'see'">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
            <el-radio :label="3">保密</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="学历" prop="education">
          <el-select
            filterable
            v-model="ruleForm.education"
            placeholder="请选择学历"
            :disabled="cztype == 'see'"
          >
            <el-option
              :label="item.title"
              :value="item.value"
              v-for="(item, index) in educationList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="是否党员" prop="cpc">
          <el-radio-group v-model="ruleForm.cpc" :disabled="cztype == 'see'">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">不是</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="人脸照片" prop="face_url">
          <el-upload
            :limit="1"
            ref="upload"
            name="file[]"
            :data="{ type: 'face' }"
            :action="ossUpload"
            :file-list="faceFileList"
            :headers="{ token: token }"
            list-type="picture-card"
            :on-remove="faceHandleRemove"
            :on-success="faceHandleAvatarSuccess"
            :disabled="cztype == 'see'"
            :before-upload="faceBeforeAvatarUpload"
            accept=".jpg,.png,.jpeg"
            :class="ruleForm.face_url ? 'hide' : ''"
          >
            <i class="el-icon-plus"></i> </el-upload
          ><!-- 已修改 -->
          <div class="pic-tips">
            人脸照片，后缀只能 jpg，图片尺寸必须大于 256*256 小于 6000*6000
          </div>
        </el-form-item>
        <el-form-item label="身份证号" prop="idcard">
          <el-input
            maxlength="18"
            v-model="ruleForm.idcard"
            :disabled="cztype != 'add'"
            placeholder="请输入身份证号"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="状态" prop="status">
          <el-radio-group v-model="ruleForm.status" :disabled="cztype == 'see'">
            <el-radio :label="0">禁用</el-radio>
            <el-radio :label="1">启用</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <div>
          <el-form-item
            :label="'住宅角色' + (index + 1)"
            v-for="(item, index) in domains"
            :key="item.re_house_id+index"
          >
            <el-select
              filterable
              @change="
                (id) => {
                  parkChange(id, index);
                }
              "
              class="w4"
              v-model="item.park_id"
              placeholder="请选择园区"
              :disabled="
                cztype == 'see' || userInfo.type == 2 || userInfo.type == 1
              "
            >
              <el-option
                :label="item1.name"
                :value="item1.id"
                v-for="(item1, index1) in parkList"
                :key="index1"
              ></el-option>
            </el-select>
            <el-select
              filterable
              @change="
                (id) => {
                  changeHouse(id, index);
                }
              "
              class="w4"
              v-model="item.re_house_id"
              placeholder="请选择房屋"
              :disabled="cztype == 'see'"
            >
              <el-option
                :disabled="houseIds.indexOf(item1.id) != -1 ? true : false"
                :label="item1.name"
                :value="item1.id"
                v-for="(item1, index1) in houseList[index]"
                :key="index1"
              ></el-option>
            </el-select>
            <!-- <el-select
              class="w4"
              v-model="item.resident_type"
              placeholder="请选择类型"
              :disabled="cztype == 'see' "
            >
              <el-option label="业主" value="1" ></el-option>
              <el-option label="家属" value="2" ></el-option>
              <el-option label="租户" value="3" ></el-option>
            </el-select> -->
            <!-- <el-select
              filterable
              v-model="item.resident_type"
              placeholder="请选择角色"
              :disabled="cztype == 'see'"
              @change="$forceUpdate()"
            >
              <el-option
                v-for="(item1, index1) in residentList"
                :key="index1"
                :label="item1.name"
                :value="item1.value"
              ></el-option>
            </el-select> -->
            <!-- <el-select
              filterable
              @change="
                (id) => {
                  changeCompany(id, index);
                }
              "
              class="w4"
              v-model="item.company_id"
              placeholder="请选择企业"
              :disabled="cztype == 'see' || userInfo.type == 2"
            >
              <el-option
                :disabled="companyIds.indexOf(item1.id) != -1 ? true : false"
                :label="item1.name"
                :value="item1.id"
                v-for="(item1, index1) in companyList[index]"
                :key="index1"
              ></el-option>
            </el-select> -->
            <el-cascader
              class="w4"
              placeholder="请选择角色"
              :disabled="item.re_house_id == '' || cztype == 'see'"
              :value="item.system_role_id"
              :options="roleList[index]"
              :show-all-levels="false"
              @change="
                (e) => {
                  roleChange(e, index);
                }
              "
              :props="{
                checkStrictly: true,
                label: 'title',
                value: 'id',
                children: 'nodes',
              }"
              clearable
            ></el-cascader>
            <el-button
              style="margin: 0 0 0 10px"
              v-if="(domains.length > 1 && cztype == 'add') || (cztype != 'add' && cztype != 'see') "
              type="danger"
              @click.prevent="removeDomain(index)"
              >删除</el-button
            >
          </el-form-item>
        </div>
        <el-form-item v-if="userInfo.type != 2 && cztype != 'see'">
          <el-button type="primary" @click="addDomain">添加住宅角色</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-dialog title="用户角色" :visible.sync="userRoleVisible">
      <el-table
        :data="userRoleData"
        :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      >
        <el-table-column align="center" label="序号" width="95">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="所属园区">
          <template slot-scope="scope">
            <span v-if="scope.row.park">{{ scope.row.park.name }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="所属企业">
          <template slot-scope="scope">
            <span v-if="scope.row.company">{{ scope.row.company.name }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="角色">
          <template slot-scope="scope">
            <span v-if="scope.row.system_role">{{
              scope.row.system_role.title
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="created_at"
          label="操作"
          width="100"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              v-if="roles.includes('/user/house_user_del')"
              @click="handleDelete(scope.row)"
              >删除角色</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="userRoleVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      @close="dialogClos"
      :close-on-click-modal="false"
      title="导入文件"
      :visible.sync="leadInVisible"
    >
      <el-upload
        ref="upload"
        class="upload-demo"
        :action="baseURL + '/company_user/import_user'"
        :headers="{ token: token }"
        drag
        :limit="1"
        :on-success="handleAvatarSuccessFile"
        :on-progress="beforeAvatarUploadFile"
        :multiple="false"
        accept=".xlsx"
      >
        <!-- accept=".xlsx,.xls" -->
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传xlsx文件</div>
        <!-- ，且不超过500kb -->
      </el-upload>
      <el-progress v-if="progressFlag" :percentage="loadProgress"></el-progress>
      <div class="error" v-if="msgData.length > 0">
        <div v-for="(item, index) in msgData" :key="index">{{ item }}</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="leadInVisible = false">取 消</el-button>
        <el-button type="primary" @click="leadInVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  houseUserList,
  houseUserAdd,
  houseUserEdit,
  houseUserDel,
  houseUserInfo,
  openPark,
  delImage,
  openRole,
  miniUserRole,
  openCompany,
  importCompany_user,
  get_park_houses,
  templateCompany_user,
} from "@/api/index";
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      // 学历列表
      educationList: [
        {
          title: "小学",
          value: 2,
        },
        {
          title: "初中",
          value: 3,
        },
        {
          title: "高中",
          value: 4,
        },
        {
          title: "专科",
          value: 5,
        },
        {
          title: "本科",
          value: 6,
        },
        {
          title: "研究生",
          value: 7,
        },
        {
          title: "其他",
          value: 1,
        },
      ],
      total: 0,
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加园区",
      token: getToken(),
      screen: {
        page: 1,
        page_size: 15,
        name: "",
        phone: "",
        park_id: "",
      },
      ruleForm: {
        name: "",
        mobile: "",
        address: "",
        bank_name: "",
        bank_code: "",
        lat: "",
        lng: "",
        status: 1,
      },
      rules1: {},
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
        idcard:[{required:true,message:'请输入身份证号'}],
        // password:[{required:true,message:'请输入密码'}]
      },
      multipleSelection: [],
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      oldImg: "",
      parkList: [],
      userRoleVisible: false,
      userRoleData: [],
      roleList: [],
      companyList: [],
      companyIds: [],
      domains: [{ park_id: "", re_house_id: "", resident_type: "" }],
      leadInVisible: false,
      baseURL: this.$store.state.baseURL,
      fileList: [],
      loadProgress: 0,
      progressFlag: false,
      msgData: [],
      faceFileList: [],
      houseList: [],
      houseIds: [],
      residentList: [
        {
          name: "业主",
          value: 1,
        },
        {
          name: "家属",
          value: 2,
        },
        {
          name: "租户",
          value: 3,
        },
      ],
    };
  },
  created() {
    if (this.userInfo.is_super != 1) {
      if (this.userInfo.type == 1) {
        this.screen.park_id = this.userInfo.park_id;
      } else if (this.userInfo.type == 2) {
        this.screen.park_id = this.userInfo.park_id;
        // this.companyIds.push(this.userInfo.company_id);
      }
    }
    this.getPark();
    this.fetchData();
  },
  methods: {
    // 人脸识别
    faceHandleAvatarSuccess(res, file) {
      if (res.code === 200) {
        if (this.ruleForm.face_url) {
          this.delImg(this.ruleForm.face_url);
        }
        // this.faceFileList.push({ url: this.imageOss + res.data.url });
        this.ruleForm.face_url = res.data.url;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.faceFileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    // 人脸识别删除
    faceHandleRemove(file) {
      this.faceFileList = [];
      this.ruleForm.face_url = "";
    },
    // 人脸识别上传限制
    faceBeforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传人脸图片大小不能超过 5MB!");
      }
      return isLt5M;
    },

    handleRemove(file) {
      this.fileList = [];
      this.ruleForm.avatar_url = "";
    },
    dialogClos() {
      this.msgData = [];
      this.$refs.upload.clearFiles();
    },
    // 上传成功
    handleAvatarSuccessFile(res, file) {
      if (res.code === 200) {
        this.$message({
          message: res.msg,
          type: "success",
          duration: "1000",
          onClose: () => {
            //onClose是message消息框消失后要执行的回调
            //此处写提示关闭后需要执行的函数
          },
        });

        this.$refs.upload.clearFiles();

        this.leadInVisible = false;
      } else {
        this.$refs.upload.clearFiles();
        this.msgData = res.data;
        this.$message({
          message: res.msg,
          type: "error",
          duration: "2000",
        });
      }
      this.fetchData();
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    // 上传进度
    beforeAvatarUploadFile(event, file, fileList) {
      this.progressFlag = true;
      this.loadProgress = Math.floor(event.percent);
      let loadProgress = Math.floor(event.percent); //这就是当前上传的进度
      //可以进行其他逻辑
      if (loadProgress == 100) {
        this.progressFlag = false;
      }
    },
    // 导入
    leadIn() {
      this.leadInVisible = true;
    },
    // 下载模板
    downloadFile() {
      templateCompany_user().then((res) => {
        if (res.code == 200) {
          window.open(res.data.download_url, "_self");
        }
      });
    },
    changeCompany(id, index) {
      this.getRole(id, index);
      this.companyIds = [];
      this.domains.forEach((item, index) => {
        if (item.company_id) {
          this.companyIds.push(item.company_id);
        }
      });
    },
    changeHouse(id, index) {
      // this.getRole(id, index);
      this.houseIds = [];
      this.domains.forEach((item, index) => {
        if (item.re_house_id) {
          this.houseIds.push(item.re_house_id);
        }
      });
    },
    // 删除
    removeDomain(index) {
      // this.companyIds = [];
      // var i = this.companyIds.findIndex((item) => {
      //   return item == this.domains[index].company_id;
      // });
      // if (i != -1) {
      //   this.companyIds.splice(i, 1);
      // }
      // this.companyList.splice(index, 1);
      this.houseIds = [];
      var i = this.houseIds.findIndex((item) => {
        return item == this.domains[index].re_house_id;
      });
      if (i != -1) {
        this.houseIds.splice(i, 1);
      }
      this.roleList.splice(index, 1);
      this.houseList.splice(index, 1);
      this.domains.splice(index, 1);
    },
    // 添加园区角色
    addDomain() {
      this.domains.push({ park_id: "", system_role_id: "" ,re_house_id:''});
      if (this.userInfo.is_super != 1) {
        this.domains[this.domains.length - 1].park_id = this.userInfo.park_id;
        this.getRole(this.userInfo.park_id, this.domains.length - 1);
        this.changeHouse();
        this.getHouse(this.userInfo.park_id, this.domains.length - 1);
      }
    },
    chongZhi() {
      this.screen = {
        page: 1,
        page_size: 15,
        name: "",
        phone: "",
        company_id: "",
        park_id: "",
      };
      if (this.userInfo.is_super != 1) {
        if (this.userInfo.type == 1) {
          this.screen.park_id = this.userInfo.park_id;
        } else if (this.userInfo.type == 2) {
          this.screen.park_id = this.userInfo.park_id;
        }
      }
      this.fetchData();
    },
    // 获取企业
    getCompany(type, id, index) {
      var data = {
        park_id: id,
        is_page: 2,
        index: index,
      };
      openCompany(data).then((response) => {
        if (type == "screen") {
        } else {
          if (type == "add") {
            this.$set(this.companyList, index, response.data.lists);
          }
        }
      });
    },

    // 查看角色
    openUserRole(val) {
      var data = {
        user_id: val.id,
        // park_id: val.park_id,
        // company_id: this.userInfo.company_id,
        source: 3,
      };
      miniUserRole(data).then((res) => {
        this.userRoleData = res.data.lists;
        this.userRoleVisible = true;
      });
    },
    // 获取角色
    getRole(id, index) {
      const data = {
        is_page: 2,
        is_tree: 1,
        role_type: 2,
        type: 4,
        park_id: this.domains[index].park_id || "",
        index:index
      };
      openRole(data).then((res) => {
        this.$set(this.roleList, index, res.data.lists);
      });
    },
    // 选择园区
    parkChange(id, index) {
      if (!id) {
        return;
      }
      this.domains[index] = { park_id: id, re_house_id: "", system_role_id: "" };
      this.getRole(id, index);
      this.changeHouse();
      this.getHouse(id, index);
    },
    getHouse(id, index) {
      const data = {
        park_id: this.domains[index].park_id || "",
        index:index
      };

      get_park_houses(data).then((res) => {
        this.$set(this.houseList, index, res.data);
      });
    },
    // 获取园区
    getPark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    roleChange(e, index) {
      if (e.length) {
        this.domains[index].system_role_id = e[0];
      } else {
        this.domains[index].system_role_id = "";
      }
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // var chone = 0;
          // this.domains.forEach((item) => {
          //   if (item.re_house_id && item.system_role_id) {
          //   } else {
          //     this.$message({
          //       message: "住宅角色未填写完整！",
          //       type: "warning",
          //     });
          //     chone++;
          //     return;
          //   }
          // });
          // if (chone != 0) {
          //   return;
          // }
          this.$confirm("确认提交？")
            .then(() => {
              const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
              });
              that.ruleForm.house_role_data = JSON.stringify(that.domains);
              houseUserEdit(that.ruleForm).then((res) => {
                loading.close();
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  // if (this.oldImg) {
                  //   that.delImg(this.oldImg);
                  // }
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 200) {
        // if (this.ruleForm.avatar_url) {
        //   this.delImg(this.ruleForm.avatar_url);
        // }
        // this.fileList.push({ url: this.imageOss + res.data.url });
        this.ruleForm.avatar_url = res.data.url;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    delImg(path) {
      delImage({ file: path }).then((ress) => {});
    },
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      this.domains = [];
      this.companyIds = [];
      this.houseIds = []
      this.houseList = []
      this.roleList = []
      this.getInfo(val.id);
      this.oldImg = val.picture;
      this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      this.domains = [];
      this.houseIds = []
      this.houseList = []
      this.roleList = []
      this.getInfo(val.id);
      this.drawer = true;
    },
    async getInfo(id) {
      var that = this;
      var data = {
        id: id,
        park_id: this.userInfo.park_id,
      };
      var list;
      await houseUserInfo(data).then((res) => {
        this.ruleForm = {
          id: res.data.info.id,
          password: "",
          type: res.data.info.type,
          id: res.data.info.id,
          phone: res.data.info.phone,
          name: res.data.info.name,
          status: res.data.info.status,
          avatar_url: res.data.info.avatar_url,
          face_url: res.data.info.face,
          idcard: res.data.info.idcard,
          sex:
            res.data.info.user_extend !== null
              ? res.data.info.user_extend.sex
              : 3,
          education:
            res.data.info.user_extend !== null
              ? res.data.info.user_extend.education
              : ""
        };
        list = res.data.info.user_park_company_rel;

        this.oldImg = res.data.info.avatar_url;
        this.fileList = [];
        if (res.data.info.avatar_url) {
          this.fileList.push({ url: this.imageOss + res.data.info.avatar_url });
        }
        this.faceFileList = [];
        if (res.data.info.face.length > 0) {
          res.data.info.face.forEach((item, index) => {
            if (index == 0) {
              this.ruleForm.face_url = item.image;
            }
            this.faceFileList.push({ url: this.imageOss + item.image });
          });
        }else{
          this.ruleForm.face_url = ''
        }
      });
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          that.domains.push({
            park_id: list[i].park_id || "",
            re_house_id: list[i].re_house_id,
            system_role_id: list[i].system_role_id,
          });
          await this.getHouse(list[i].id, i);
          await  this.getRole(list[i].id, i); 
        }
      }
    },
    handleDelete(val) {
      const data = {
        id: val.user_id,
        role_id: val.system_role_id,
        park_id: val.park_id,
        re_house_id: val.re_house_id,
      };
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          houseUserDel(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.userRoleVisible = false;
            that.fetchData();
            // that.openUserRole(val.user_id);
          });
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm(formName) {
      var that = this;
      var chone = 0;
      this.domains.forEach((item) => {
        if (item.re_house_id && item.system_role_id) {
        } else {
          this.$message({
            message: "住宅角色未填写完整！",
            type: "warning",
          });
          chone++;
          return;
        }
      });
      if (chone != 0) {
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
              });
              that.ruleForm.house_role_data = JSON.stringify(that.domains);
              houseUserAdd(that.ruleForm).then((res) => {
                loading.close();
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
        })
        .catch(() => {});
    },
    addMenu() {
      this.drawerTitle = "添加用户";
      this.cztype = "add";
      this.ruleForm = {
        phone: "",
        name: "",
        status: 1,
        house_role_data: "",
        type: 2,
        avatar_url: "",
        sex: 3,
        education: "",
        password: "",
        face_url: "",
        idcard: "",
      };
      this.drawer = true;
      this.fileList = [];
      this.faceFileList = [];
      this.companyIds = [];
      this.domains = [{ park_id: "", system_role_id: "",re_house_id:"" }];
      if (this.userInfo.is_super != 1) {
        this.domains[0].park_id = this.userInfo.park_id;
        this.parkChange(this.userInfo.park_id, 0);
      }
      this.drawer = true;
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
    },
    delHouse_user(val) {
      var that = this;
      let data = {
        id: val.id,
        park_id: val.park_id,
      };
      this.$confirm("确认删除？")
        .then(() => {
          houseUserDel(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      houseUserList(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 70px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.screenInput {
  width: 200px;
  margin-right: 10px;
  margin-bottom: 5px;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.upload-demo {
  ::v-deep .el-upload {
    width: 100%;
    .el-upload-dragger {
      width: 100%;
    }
  }
}
.error {
  width: 100%;
  max-height: 100px;
  overflow: auto;
  padding: 10px;
  border: 1px solid;
  color: red;
  div {
    line-height: 20px;
  }
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
</style>
